import styles from './viewLoadingCard.module.css';

export interface IViewLoadingCardProps {
  /** What is loading, e.g. "Loading progress tracker…". */
  label: string;
  /** The view's own card frame, so the loading state and the loaded view
   *  occupy the same box. */
  className: string | undefined;
}

/**
 * The loading card the page's full-width views (Progress Tracker, Work Plan)
 * show while their body prepares. Every loading phase of a view renders this
 * same card, so consecutive phases read as one continuous state. The message
 * is delay-gated in CSS: a fast mount never flashes it.
 */
export function ViewLoadingCard({ label, className }: IViewLoadingCardProps) {
  return (
    <div className={className}>
      <div className={styles.loading} role="status" aria-live="polite">
        {label}
      </div>
    </div>
  );
}
